import { render, staticRenderFns } from "./automobileFive.vue?vue&type=template&id=3956860d&scoped=true"
import script from "./automobileFive.vue?vue&type=script&lang=js"
export * from "./automobileFive.vue?vue&type=script&lang=js"
import style0 from "./automobileFive.vue?vue&type=style&index=0&id=3956860d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956860d",
  null
  
)

export default component.exports